import ContentLayout from '@/layouts/content-layout'
import PrivilegeView from '@/sections/privilege/view/privilege-view'

export default function PrivilegePage() {
  return (
    <ContentLayout title="ของรางวัล">
      <PrivilegeView />
    </ContentLayout>
  )
}
